import React, {useContext, useState} from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
    Avatar,
    Box,
    Button,
    Card,
    CardActions,
    CardContent,
    Dialog,
    DialogTitle,
    LinearProgress,
    Divider,
    Typography,
    makeStyles
} from '@material-ui/core';
import MusicSnackbar from 'src/components/MusicSnackbar';
import MusicianContext from 'src/musicianContext';
import { firebase } from 'src/db/db';
import { ReactMediaRecorder } from "react-media-recorder";
const storageRef = firebase.storage().ref();

const useStyles = makeStyles(() => ({
    root: {},
    avatar: {
        height: 100,
        width: 100
    }
}));

const Recorder = (props) => {
    const { className, updateMusicView, intent, open, setOpen } = props;
    const classes = useStyles();
    const musician = useContext(MusicianContext);
    const [isSnackbarOpen, setIsSnackbarOpen] = useState(false);

    //Voice State
    const [blobURL, setBlobURL] = useState("");
    const [recording, setRecordName] = useState("Record");
    const [progress, setProgress] = useState(0);
    const [isRecording, setIsRecording] = useState(false);
    const [fileName, setFileName] = useState("");

    const SCRIPTS = {
        "welcome.speech.mp3": `Hey, it's ${musician.musician}, and welcome to my experience on Alexa.`,
        "help.global.speech.mp3": "You can ask me 'where can I listen to your music?', 'how can I connect?', or 'play a song'. Which would you like?",
        "end.speech.mp3": `Thanks for vibing with me! This is ${musician.musician}, signing off. See ya next time!`,
        "unhandled.global.speech.mp3": "Uhhhhhhhmm... I'm still working on that one.",
        "play.song.intro.mp3": "What do you think of my new song?",
        "where.can.i.find.your.music.prompt.mp3": `You can find my music on all music streaming platforms. Just search ${musician.musician}.` ,
        "connect.prompt.mp3": `You can connect with me on all social media sites @{${musician.musician}}`,
        "where.are.you.from.speech.mp3": "It's really important for me to stay connected with my fanbase. To help, can you tell me what state you're in?",          
    };

    const onStop = async recordedBlob => {
        setBlobURL(recordedBlob);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const handleSnackbarClose = async () => {
        setOpen(false);
        await updateMusicView();
    };

    const selectImage = () => {
        document.getElementById("voiceFileUpload").click();
    };

    const handleChange = (e) => {
        const file = e.target.files[0];
        if(file) {
            const url = URL.createObjectURL(file);
            setBlobURL(url)
        }
    };

    const startRecordingStatus = async () => {
        setRecordName("3");
        await new Promise(resolve => setTimeout(resolve, 1000));
        setRecordName("2");
        await new Promise(resolve => setTimeout(resolve, 1000));
        setRecordName("1");
        await new Promise(resolve => setTimeout(resolve, 1000));
        setProgress(0);
        setIsRecording(true);
        setRecordName("Recording");
    };

    const stopRecordingStatus = () => {
        setIsRecording(false);
        setRecordName("Record");
    };

    const uploadMP3 = async () => {
        let file = await fetch(blobURL).then(r => r.blob());
        let voiceOverFileName = fileName;
        if (voiceOverFileName.length > 0) {
          voiceOverFileName = voiceOverFileName.replace(/[ ]/g, ".");
          voiceOverFileName = voiceOverFileName + ".mp3";
        }
        const uploadTask = storageRef
          .child(`musicians/${musician.musician}/intents/${intent}`)
          .put(file);
        uploadTask.on(
          "state_changed",
          snapshot => {
            const progressNumber = Math.round(
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100
            );
            setProgress(progressNumber);
          },
          e => console.error(e),
          async () => {
            setBlobURL("");
            setFileName("");
            setIsSnackbarOpen(true);
          }
        );
    };

    return (
        <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
            <DialogTitle id="simple-dialog-title">Recording Studio</DialogTitle>
            <Card className={clsx(classes.root, className)}>
                <CardContent>
                    <Box alignItems="center" display="flex" flexDirection="column">
                        <Avatar className={classes.avatar} src={musician.logo} />
                        {
                            intent ?
                            <Box>
                                <Typography className={classes.dateText} color="textSecondary" variant="body1">
                                    <strong>Now Recording: </strong> {intent}
                                </Typography>
                                <Typography className={classes.dateText} color="textSecondary" variant="body1">
                                    <strong>Script:  </strong> {musician.musician ? SCRIPTS[intent] : "..."}
                                </Typography>
                            </Box>
                            :
                            <Typography className={classes.dateText} color="textSecondary" variant="body1">
                                {`Artist Name: ${musician.musician ? musician.musician : "..."}`}
                            </Typography>
                        }
                    </Box>
                </CardContent>

                <Divider />
                <Box>
                    {
                        blobURL.length > 0 ?
                        <Box mt={1} alignItems="center" display="flex" flexDirection="column">
                            <audio
                                src={blobURL}
                                controls="controls"
                            />
                        </Box> : ""
                    }
                    
                    <Box mt={1} alignItems="center" display="flex" flexDirection="column">

                        <ReactMediaRecorder
                            audio
                            onStop={onStop}
                            render={({
                                status,
                                startRecording,
                                stopRecording,
                                mediaBlobUrl
                            }) => (
                                <Box display="flex" justifyContent="space-around" width="100%">
                                    <Button
                                        onClick={() => {
                                            startRecordingStatus().then(() => {
                                                startRecording();
                                            });
                                        }}
                                        disabled={isRecording}
                                        color="primary"  
                                        variant="contained"
                                        size="large"
                                    >
                                        <b>{recording}</b>
                                    </Button>
                                    {
                                        isRecording ?
                                        <Button
                                            onClick={() => {
                                                stopRecordingStatus();
                                                stopRecording();
                                            }}
                                            disabled={!isRecording}
                                            size="large"
                                        >
                                            <b>Stop</b>
                                        </Button> :
                                        <Button color="primary" variant="outlined" onClick={selectImage} size="large">
                                            Select File
                                        </Button>
                                    }
                                    <input id="voiceFileUpload" hidden style={{ opacity: 0 }} type="file" accept="audio/*" onChange={handleChange} />
                                </Box>
                            )}
                        />
                    </Box>
                </Box> 

                <CardActions>
                    <Button color="primary" fullWidth variant="contained" onClick={uploadMP3} disabled={!blobURL.length > 0}>
                            Upload
                    </Button>        
                </CardActions>
                <LinearProgress variant="determinate" value={progress} />

                <MusicSnackbar 
                    text={`Success! Uploaded ${intent}`}
                    setOpen={setIsSnackbarOpen}
                    open={isSnackbarOpen}
                    severity="success"
                    onClose={handleSnackbarClose}
                    updateMusicView={updateMusicView}
                />
            </Card>
        </Dialog>
    );
};

Recorder.propTypes = {
  className: PropTypes.string
};

export default Recorder;
